module.exports = __webpack_public_path__ + "assets/a-shuben2.98490b15.svg";